import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function SubscriberEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["email"]} children={children} />
    );
}

export function SubscriberCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"fabricSubscriber"} children={children} />
    );
}